import React from 'react';
import clsx from 'clsx';
import Chip from '@material-ui/core/Chip';

import { TopUpTransactionStatusType } from 'features/finance/ts/PartnerBalanceTransaction';

import { useStyles } from './styles';

export type TopUpTransactionStatusColorScheme = keyof typeof TopUpTransactionStatusType;

interface TopUpTransactionStatusProps {
    colorScheme: TopUpTransactionStatusColorScheme;
    label: string;
}

export const TopUpTransactionStatus: React.FC<TopUpTransactionStatusProps> = ({ colorScheme, label }) => {
    const classes = useStyles();

    return <Chip className={clsx(classes.chip, classes[colorScheme])} label={label} />;
};
